export default __webpack_public_path__ + "assets/images/a8b59cdc7030ef3b36f11c601b19f017.png";